import { language, useSetLanguage } from "@/hooks/languageHooks";
import { faChevronDown, faEarthEurope } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "frontend-components";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
    const { t } = useTranslation();
    const { handleLanguageChange, currentLanguage } = useSetLanguage();
    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger>
                    <FontAwesomeIcon icon={faEarthEurope} className="pr-1" />
                    <span>{t("common.languages.short." + currentLanguage)}</span>
                    <FontAwesomeIcon icon={faChevronDown} className="pl-1" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem
                        onClick={(e) => {
                            e.preventDefault();
                            handleLanguageChange(language.norwegian);
                        }}
                    >
                        {t("common.languages.long.nb")}
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        onClick={(e) => {
                            e.preventDefault();
                            handleLanguageChange(language.english);
                        }}
                    >
                        {t("common.languages.long.en")}
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
}
